<template>
  <div>
    <div>
      <div v-if="isEdit" class="Kanit">
        <div class="text-center mb-4">
          <h3 v-if="input.id" style="color: #0c4d9d" class="mb-1">
            กรุณาแก้ไขที่อยู่
          </h3>
          <h3 v-else style="color: #0c4d9d" class="mb-1">กรุณาเพิ่มที่อยู่</h3>
          <div v-if="query.user_type == 'customer'">
            <div style="font-size: 11px; color: red">
              *ที่อยู่ใช้เพื่อการขอราคาสินค้าจากร้านผู้แทนขาย
            </div>
            <div style="font-size: 11px; color: red">
              *ที่อยู่ใช้เพื่อการจัดส่งสินค้าหลังการชำระเงิน
            </div>
          </div>
        </div>
        <ValidationObserver ref="observer" tag="form">
          <form>
            <ValidationProvider
              :name="'ชื่อจริง'"
              :rules="'required'"
              key="firstname"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                large
                class="mb-0"
                outlined
                @input="input.first_name = removeHiddenSpace($event)"
                v-model="input.first_name"
                label="Firstname"
                placeholder="ชื่อจริง"
                :error-messages="errors"
                :valid="valid"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :name="'นามสกุล'"
              :rules="'required'"
              key="lastname"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                outlined
                name="lastname"
                class="mb-0"
                @input="input.last_name = removeHiddenSpace($event)"
                v-model="input.last_name"
                label="Lastname"
                placeholder="นามสกุล"
                :error-messages="errors"
                :valid="valid"
              ></v-text-field>
            </ValidationProvider>

            <ValidationProvider
              :name="'เบอร์โทรศัพท์'"
              :rules="'required'"
              key="phoneno"
              v-slot="{ errors, valid }"
            >
              <v-text-field
                rows="4"
                auto-grow
                outlined
                type="number"
                name="phoneno"
                v-model="input.phone_number"
                label="Phone number"
                placeholder="เบอร์โทรศัพท์"
                :error-messages="errors"
                :valid="valid"
              ></v-text-field>
            </ValidationProvider>
            <template v-if="isNewUser">
              <ValidationProvider
                :name="'อีเมล์'"
                :rules="'required|email'"
                key="email"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  outlined
                  name="email"
                  class="mb-0"
                  v-model.trim="input.email"
                  v-removeHiddenSpace
                  label="Email"
                  placeholder="อีเมล์"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
            </template>
            <ValidationProvider
              :name="'รหัสไปรษณีย์'"
              :rules="'required'"
              key="zipcode"
              v-slot="{ errors }"
            >
              <thai-address-input
                v-model="input.zip_code"
                type="zipcode"
                @select="onSelectAddress"
                :placeholder="`รหัสไปรษณีย์`"
                :label="`Zipcode`"
                :error-messages="errors"
                :hide-details="errors.length == 0"
              ></thai-address-input>
            </ValidationProvider>
            <div style="clear: both"></div>
            <ValidationProvider
              :name="'จังหวัด'"
              :rules="'required'"
              key="province"
              v-slot="{ errors }"
            >
              <thai-address-input
                v-model="input.province"
                type="province"
                :label="`Province`"
                placeholder="จังหวัด"
                @select="onSelectAddress"
                :error-messages="errors"
                :hide-details="errors.length == 0"
              ></thai-address-input>
            </ValidationProvider>
            <div style="clear: both"></div>

            <ValidationProvider
              :name="'อำเภอ/เขต'"
              :rules="'required'"
              key="amphoe"
              v-slot="{ errors }"
            >
              <thai-address-input
                v-model="input.sub_district"
                type="amphoe"
                :label="`District`"
                placeholder="อำเภอ/เขต"
                @select="onSelectAddress"
                :error-messages="errors"
                :hide-details="errors.length == 0"
              ></thai-address-input>
            </ValidationProvider>
            <div style="clear: both"></div>
            <ValidationProvider
              :name="'ตำบล/แขวง'"
              :rules="'required'"
              key="district"
              v-slot="{ errors }"
            >
              <thai-address-input
                v-model="input.district"
                type="district"
                :label="'Sub-district'"
                placeholder="ตำบล/แขวง"
                @select="onSelectAddress"
                :error-messages="errors"
                :hide-details="errors.length == 0"
              ></thai-address-input>
            </ValidationProvider>
            <div style="clear: both"></div>

            <ValidationProvider
              :name="'ที่อยู่'"
              :rules="'required'"
              key="addressno"
              v-slot="{ errors }"
            >
              <v-textarea
                @input="input.address1 = removeHiddenSpace($event)"
                v-model="input.address1"
                outlined
                rows="3"
                label="Address"
                class="mb-6"
                placeholder="ที่อยู่ บ้านเลขที่ หมู่บ้าน ถนน"
                :error-messages="errors"
                :hide-details="errors.length == 0"
              ></v-textarea>
            </ValidationProvider>

            <div class="text-center mt-0 mb-4">
              <v-btn
                @click="editAddress(input.id)"
                v-if="input.id"
                block
                :loading="saveloading"
                dark
                color="#0c4d9d"
              >
                <span>แก้ไขที่อยู่จัดส่ง</span>
              </v-btn>
              <v-btn
                @click="addAddress"
                v-else
                block
                :loading="saveloading"
                dark
                color="#0c4d9d"
              >
                <span>เพิ่มที่อยู่จัดส่ง</span>
              </v-btn>
              <v-btn text block @click="cancelAddress">ยกเลิก</v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div v-else>
        <div class="text-center">
          <div v-if="query.user_type == 'customer'">
            <div class="mb-4">
              <h3 style="color: #0c4d9d" class="mb-1">กรุณาเลือกที่อยู่</h3>
              <div style="font-size: 11px; color: red">
                *ที่อยู่ใช้เพื่อการขอราคาสินค้าจากร้านผู้แทนขาย
              </div>
              <div style="font-size: 11px; color: red">
                *ที่อยู่ใช้เพื่อการจัดส่งสินค้าหลังการชำระเงิน
              </div>
            </div>
          </div>
          <h3 v-else style="color: #0c4d9d" class="mb-4">ที่อยู่จัดส่ง</h3>
        </div>
        <div>
          <div
            @click="activeAddress = item.id"
            v-for="item in address"
            :key="item.id"
            class="my-2"
            style="border: solid 0.5px #0c4d9d; border-radius: 12px"
          >
            <v-row style="position: relative" dense class="px-3 py-1">
              <div style="position: absolute; right: 5px; top: 0px">
                <v-btn @click.stop="clickEdit(item)" icon small>
                  <v-icon small>mdi-square-edit-outline</v-icon>
                </v-btn>
              </div>
              <v-col cols="8">
                <div style="color: #0c4d9d">
                  {{ item.first_name + " " + item.last_name }}
                </div>
                <div>{{ item.phone_number }}</div>
                <div style="font-size: 10px">
                  {{
                    `${item.address1}, แขวง${item.sub_district} เขต${item.district} จังหวัด${item.province} ${item.zip_code}`
                  }}
                </div>
                <div
                  v-if="activeAddress == item.id && !isCustomerProfile"
                  style="font-size: 10px; color: #ff6060"
                  class="mt-2"
                >
                  ที่อยู่ในการรับสินค้า
                </div>
              </v-col>
              <v-col
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                cols="4"
              >
                <div v-if="activeAddress == item.id && !isCustomerProfile">
                  <v-icon style="font-size: 40px; color: green"
                    >mdi-check-bold</v-icon
                  >
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            @click="newAddressBtn"
            style="
              border: solid 0.5px #0c4d9d;
              border-radius: 12px;
              margin-top: 15px;
            "
          >
            <v-row class="px-3" style="color: #a2a2a2" dense>
              <v-col cols="6">เพิ่มที่อยู่ใหม่</v-col>
              <v-col class="text-right" cols="6">
                <v-icon style="font-size: 20px">mdi-plus</v-icon>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>

      <div
        v-if="!isEdit && !isCustomerProfile && activeAddress"
        @click="
          $emit(
            'onSubmitButton',
            address.find((el) => el.id == activeAddress)
          )
        "
        v-ripple
        :disabled="!activeAddress"
        class="addcartbtn Kanit myshadow"
      >
        <p v-if="!saveloading && !proploading">ยืนยันที่อยู่</p>
        <div v-else>
          <v-progress-circular
            indeterminate
            size="35"
            color="white"
          ></v-progress-circular>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UploadFile from "@/components/UploadProfile";
import ThaiAddressInput from "@/components/ThaiAddressInput";
import Loading from "@/components/Loading.vue";
export default {
  props: {
    proploading: {
      default: false,
    },
  },
  data() {
    return {
      isEdit: false,
      showTaxDialog: false,
      loading: true,
      saveloading: false,

      input: {
        first_name: "",
        last_name: "",
        zip_code: "",
        email: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
        phone_number: "",
      },
      taxid: "",
    };
  },
  components: {
    Loading,
    UploadFile,
    ThaiAddressInput,
  },
  computed: {
    isNewUser() {
      return this.$store.state.isNewUser;
    },
    activeAddress: {
      get() {
        return this.$store.state.activeAddress;
      },
      set(val) {
        this.$store.state.activeAddress = val;
      },
    },
    address() {
      return this.$store.state.address;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    isCustomerProfile() {
      return this.$store.state.redirect == "CustomerProfile" ? true : false;
    },
  },

  methods: {
    removeReddot(e) {
      this.input.email = removeHiddenSpace(e);
    },
    checkFeyvery(data) {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersfeyverly",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                phoneno: vm.input.phone_number,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.$store.state.registerData = {
                ...data,
                phoneno: vm.input.phone_number,
              };
              if (response.data.data[0].status) {
                // true
                vm.$store.state.registerType = "customer";
                vm.query.view = "Login";
              } else {
                //false
                vm.$store.state.registerType = "customer";
                vm.query.view = "OTP";
              }
            } else {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              resolve();
            }
          });
      });
    },

    clickEdit(item) {
      this.isEdit = true;
      Object.assign(this.input, item);
    },
    async addAddress() {
      if (!this.saveloading) {
        var vm = this;
        var data = {
          userid: vm.$store.state.userid,
          apptype: vm.query.apptype,
          pageid: this.query.pageid,
          ...this.input,
          email: vm.removeHiddenSpace(vm.input.email),
        };
        var isValid = await this.$refs.observer.validate();
        if (isValid) {
          this.saveloading = true;
          if (vm.isNewUser) {
            await vm.checkFeyvery(data);
          } else {
            axios
              .post(
                "https://communitybotbyzwizai.herokuapp.com/toainfocustomer-createaddress",
                data,
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              )
              .then(async (response) => {
                vm.saveloading = false;

                if (response.data && response.data.responsecode == 400) {
                  await vm.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  return;
                } else if (response.data.responsecode == 200) {
                  await vm.$swal.fire({
                    text: "เพิ่มที่อยู่สำเร็จ",
                    icon: "success",
                  });
                  vm.address = response.data.data;
                  vm.activeAddress = vm.address[vm.address.length - 1].id;
                  vm.$forceUpdate();
                  vm.isEdit = false;
                } else if (response.data.responsecode == 401) {
                  await vm.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  vm.query.view = "Login";
                }
              });
          }
        }
      }
    },
    cancelAddress() {
      this.isEdit = false;
      this.input = {
        first_name: "",
        last_name: "",
        phone_number: "",
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
      };
    },
    newAddressBtn() {
      this.isEdit = true;
      this.input = {
        first_name: "",
        last_name: "",
        phone_number: "",
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
      };
    },
    onSelectAddress(address) {
      this.input.sub_district = address.amphoe;
      this.input.district = address.district;
      this.input.province = address.province;
      this.input.zip_code = address.zipcode;
    },

    async editAddress(id) {
      var vm = this;
      var data = {
        userid: vm.$store.state.userid,
        apptype: vm.query.apptype,
        pageid: vm.query.pageid,
        addressid: id,
        ...vm.input,
      };

      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (!vm.saveloading) {
          vm.saveloading = true;
          axios
            .patch(
              "https://communitybotbyzwizai.herokuapp.com/toainfocustomer-updateaddress",
              data,
              {
                headers: {
                  AUTHORIZATION: "Bearer xxx xxx",
                },
              }
            )
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                await vm.$swal.fire({
                  text: "แก้ไขที่อยู่สำเร็จ",
                  icon: "success",
                });
                vm.address = response.data.data;
                vm.activeAddress = vm.address[vm.address.length - 1].id;
                vm.$forceUpdate();
                vm.isEdit = false;
              }
            });
        }
      }
    },
  },
};
</script>